module.exports = __webpack_public_path__ + "static/media/kids_la.d7ce8b07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/normals/kids_la.jpg
// module id = 414
// module chunks = 0